// @flow
import * as React from 'react';

import FiltersActionsContext from '../FiltersActionsContext';

export default function useFiltersActions() {
  return React.useContext(FiltersActionsContext);
}
